var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[_c('a',{staticClass:"cursor-pointer",class:_vm.addClass,attrs:{"href":_vm.vLink.href},on:{"click":_vm.redirect}},[(_vm.icon)?_c('font-awesome-icon',{class:_vm.iconClass,attrs:{"icon":_vm.icon}}):_vm._e(),_vm._v(" "+_vm._s(_vm.tr(_vm.label))+" ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }